// src/pages/CategoriaEdit.js

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../Config';

const CategoriaEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [nombre, setNombre] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const fetchCategoria = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/categorias/${id}`);
        setNombre(response.data.nombre || '');
        setCargando(false);
      } catch (error) {
        console.error(error);
        setMensaje('❌ Error al cargar la categoría');
        setCargando(false);
      }
    };

    fetchCategoria();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_BASE_URL}/api/categorias/${id}`, {
        nombre,
      });
      setMensaje('✅ Categoría actualizada correctamente');
      setTimeout(() => navigate('/admin-categorias'), 1500);
    } catch (error) {
      console.error(error);
      setMensaje('❌ Error al actualizar categoría');
    }
  };

  const handleCancel = () => {
    navigate('/admin-categorias');
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">Editar Categoría</h2>

        {cargando ? (
          <p className="text-gray-600">Cargando categoría...</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block mb-1">Nombre:</label>
              <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                required
                className="w-full border px-3 py-2 rounded"
              />
            </div>

            <div className="flex justify-between">
              <button
                type="submit"
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Guardar Cambios
              </button>
              <button
                type="button"
                onClick={handleCancel}
                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
              >
                Cancelar
              </button>
            </div>
          </form>
        )}

        {mensaje && <p className="mt-4 text-center">{mensaje}</p>}
      </div>
    </div>
  );
};

export default CategoriaEdit;
